var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208,
    height: 23,
    viewBox: "0 0 208 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.3849 9.18438L96.7514 0.36792H93.6848H91.7682L89.085 5.35114L91.3849 9.18438Z",
    fill: "#6061E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7007 16.851L91.614 21.8342H94.4506H96.3672L91.0006 12.6344L88.7007 16.851Z",
    fill: "#6061E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.8342V0.36799H6.9305C13.1557 0.36799 17.1729 4.66122 17.1729 10.9477V11.2237C17.1729 17.5103 13.1557 21.8342 6.9305 21.8342H0ZM6.89984 4.38523H4.44656V17.8169H6.89984C10.2731 17.8169 12.573 15.4556 12.573 11.1931V11.0397C12.573 6.77717 10.2731 4.38523 6.89984 4.38523Z",
    fill: "#231D2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8703 21.8342L25.5675 0.245326H29.7994L37.4965 21.8342H32.8967L31.302 17.1729H23.9115L22.3476 21.8342H17.8703ZM25.2608 13.2477H29.9527L27.6221 6.25585L25.2608 13.2477Z",
    fill: "#231D2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0524 21.8342V4.47723H36.6551V0.36799H51.8655V4.47723H46.4683V21.8342H42.0524Z",
    fill: "#231D2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0219 21.8342L58.7191 0.245326H62.951L70.6481 21.8342H66.0482L64.4536 17.1729H57.0631L55.4991 21.8342H51.0219ZM58.4124 13.2477H63.1043L60.7737 6.25585L58.4124 13.2477Z",
    fill: "#231D2C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2578 10.8557L83.6953 21.8342H78.7581L85.1059 10.9171L79.034 0.36799H84.0939L90.2578 10.8557Z",
    fill: "#231D2C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5146 21.8342V0.36799H106.66C111.474 0.36799 114.51 3.15859 114.51 7.72782V7.78915C114.51 12.7264 110.984 15.2103 106.476 15.3023H103.961V21.8342H99.5146ZM106.445 11.3157H103.961V4.38523H106.384C108.745 4.38523 110.033 5.61187 110.033 7.85048V7.88115C110.033 9.87443 108.745 11.3157 106.445 11.3157Z",
    fill: "#6061E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.423 21.8342V0.36799H121.87V17.7556H130.548V21.8342H117.423Z",
    fill: "#6061E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.35 22.2021C135.646 22.2021 131.66 17.7249 131.66 11.3157V10.9477C131.66 4.50789 135.708 0 141.381 0C147.085 0 151.071 4.47723 151.071 10.8864V11.2544C151.071 17.6636 147.024 22.2021 141.35 22.2021ZM146.472 11.2237C146.472 15.4556 144.356 18.0929 141.381 18.0929C138.406 18.0929 136.229 15.425 136.229 11.1931V10.9784C136.229 6.74651 138.345 4.10924 141.35 4.10924C144.325 4.10924 146.472 6.77717 146.472 11.0091V11.2237Z",
    fill: "#6061E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.588 21.8342V0.36799H162.653C165.137 0.36799 167.13 1.07331 168.479 2.42261C169.644 3.58791 170.288 5.27454 170.288 7.39049V7.51316C170.288 10.7637 168.663 12.8184 166.302 13.861L170.871 21.8342H165.781L161.825 14.781H159.034V21.8342H154.588ZM162.315 10.8557H159.034V4.38523H162.223C164.493 4.38523 165.811 5.45854 165.811 7.60515V7.63582C165.811 9.56777 164.585 10.8557 162.315 10.8557Z",
    fill: "#6061E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.814 21.8342V0.36799H187.644V4.38523H178.23V9.01579H186.509V13.033H178.23V17.8169H187.767V21.8342H173.814Z",
    fill: "#6061E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.273 21.8342V0.36799H199.338C201.822 0.36799 203.815 1.07331 205.165 2.42261C206.33 3.58791 206.974 5.27454 206.974 7.39049V7.51316C206.974 10.7637 205.349 12.8184 202.987 13.861L207.556 21.8342H202.466L198.51 14.781H195.719V21.8342H191.273ZM199.001 10.8557H195.719V4.38523H198.909C201.178 4.38523 202.497 5.45854 202.497 7.60515V7.63582C202.497 9.56777 201.27 10.8557 199.001 10.8557Z",
    fill: "#6061E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0551b520cc417932dd21aa87540e0742.svg";
export { ForwardRef as ReactComponent };